@if(this.tableLoading) {
  <snelstart-ui-spinner size="extraLarge"></snelstart-ui-spinner>
}
@if (this.showTableOverzicht && !this.tableLoading) {
    <snelstart-ui-table [config]="tableConfigOverzicht">
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Klant" name="clientName">
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="false" [showSort]="true" displayName="DoMa IB/VPB" name="statusDoorlopendeMachtiging">
          <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        Activeren
                    } @else if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusDoorlopendeMachtiging === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showInitialFilterOptions]="true" [showSort]="true" displayName="DoMa TSL" name="statusDoorlopendeMachtigingTsg">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        Activeren
                    } @else if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusDoorlopendeMachtigingTsg === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showSort]="false" displayName="DoMa BTW"
                                name="statusDoorlopendeMachtigingOb">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        Activeren
                    } @else if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusDoorlopendeMachtigingOb === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showSort]="false"
                                displayName="SBA IB/VPB {{this.year}}" name="statusMachtigingHuidigJaar">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        In behandeling
                    } @else if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusMachtigingHuidigJaar === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showSort]="false"
                                displayName="SBA TSL {{this.year}}" name="statusMachtigingHuidigJaarTsg">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        In behandeling
                    } @else if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusMachtigingHuidigJaarTsg === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showSort]="false" displayName="SBA BTW {{this.year}}" name="statusMachtigingVorigJaarTsg">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusMachtigingVorigJaarTsg === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusMachtigingVorigJaarTsg === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        In behandeling
                    } @else if (record.statusMachtigingVorigJaarTsg === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusMachtigingVorigJaarTsg === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusMachtigingVorigJaarTsg === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusMachtigingHuidigJaarOb === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="true" [showSort]="false" displayName="VIA {{this.year}}" name="statusMachtigingVorigJaarVia">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    @if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.ONTVANGEN) {
                        Ontvangen
                    } @else if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.IN_BEHANDELING) {
                        Activeren
                    } @else if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.AFGEKEURD) {
                        Afgekeurd
                    } @else if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.ACTIEF) {
                        Actief
                    } @else if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.NIET_ACTIEF) {
                        Niet actief
                    } @else if (record.statusMachtigingVorigJaarVia === MumaEntityMachtigingStatus.CONTROLEREN) {
                        Wordt gecontroleerd
                    } @else {
                        -
                    }
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
    </snelstart-ui-table>
}
@if (this.showTable) {
    <snelstart-ui-table [config]="tableConfig">
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Machtiging" name="type">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    <ng-container *ngIf="record.type.startsWith('SBA')">
                        <a *ngIf="record.type === 'SBA_VpB_2024'">Machtiging servicebericht aanslag
                            vennootschapsbelasting 2024</a>
                        <a *ngIf="record.type === 'SBA_VpB_2025'">Machtiging servicebericht aanslag
                            vennootschapsbelasting 2025</a>
                        <a *ngIf="record.type === 'SBA_VpB_2026'">Machtiging servicebericht aanslag
                            vennootschapsbelasting 2026</a>
                        <a *ngIf="record.type === 'SBA_IH_2024'">Machtiging servicebericht aanslag inkomstenbelasting
                            2024</a>
                        <a *ngIf="record.type === 'SBA_IH_2025'">Machtiging servicebericht aanslag inkomstenbelasting
                            2025</a>
                        <a *ngIf="record.type === 'SBA_IH_2026'">Machtiging servicebericht aanslag inkomstenbelasting
                            2026</a>
                        <a *ngIf="record.type === 'SBA_OB_2024'">Machtiging servicebericht aanslag omzetbelasting
                            2024</a>
                        <a *ngIf="record.type === 'SBA_OB_2025'">Machtiging servicebericht aanslag omzetbelasting
                            2025</a>
                        <a *ngIf="record.type === 'SBA_OB_2026'">Machtiging servicebericht aanslag omzetbelasting
                            2026</a>
                        <a *ngIf="record.type === 'SBA_TSG_2024'">Machtiging servicebericht toeslagen 2024</a>
                        <a *ngIf="record.type === 'SBA_TSG_2025'">Machtiging servicebericht toeslagen 2025</a>
                        <a *ngIf="record.type === 'SBA_TSG_2026'">Machtiging servicebericht toeslagen 2026</a>
                    </ng-container>
                    <ng-container *ngIf="record.type.startsWith('VIA')">
                        <a *ngIf="record.type === 'VIA_2024'">Machtiging gegevens vooraf ingevulde aangifte 2024</a>
                        <a *ngIf="record.type === 'VIA_2025'">Machtiging gegevens vooraf ingevulde aangifte 2025</a>
                    </ng-container>
                    <ng-container *ngIf="record.type.startsWith('DoMa')">
                        <a *ngIf="record.type === 'DoMa_IH'">Doorlopende machtiging inkomstenbelasting</a>
                        <a *ngIf="record.type === 'DoMa_OB'">Doorlopende machtiging omzetbelasting</a>
                        <a *ngIf="record.type === 'DoMa_VpB'">Doorlopende machtiging vennootschapsbelasting</a>
                        <a *ngIf="record.type === 'DoMa_TSG'">Doorlopende machtiging toeslagen</a>
                    </ng-container>
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
        <snelstart-ui-table-col [showFilter]="false" [showSort]="false" displayName="Status" name="machtigingStatus">
            <snelstart-ui-table-col-data>
                <ng-template let-record="record">
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.ONTVANGEN">Ontvangen</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && !this.checkIsOptInMachtiging(record.mumaRequest.dienst)">In
                        behandeling</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.IN_BEHANDELING && this.checkIsOptInMachtiging(record.mumaRequest.dienst)">Activeren</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.AFGEKEURD">Afgekeurd</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.ACTIEF">Actief</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.NIET_ACTIEF">Niet actief</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.CONTROLEREN">Wordt
                        gecontroleerd</a>
                    <a *ngIf="record.machtigingStatus === MumaEntityMachtigingStatus.UNKNOWN">Onbekend</a>
                </ng-template>
            </snelstart-ui-table-col-data>
        </snelstart-ui-table-col>
    </snelstart-ui-table>
}

